import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment'; // Importe seu modelo de Departamento
import { Departamento } from '../models/Departamento';

@Injectable({
  providedIn: 'root'
})
export class DepartamentoService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<Departamento[]>(`${environment.urlApi}/departamentos`);
  }

  // Método para pegar todos os departamentos ativos
  listarDepartamentosAtivos() {
    return this.http.get<Departamento[]>(`${environment.urlApi}/departamentos/ativos`);
  }

  // Método para buscar um departamento por ID
  buscarDepartamentoPorId(id: number) {
    return this.http.get<Departamento>(`${environment.urlApi}/departamentos/${id}`);
  }

  buscarDepartamentoPorCdDepartamento(cdDepartamento: number) {
    return this.http.get<Departamento>(`${environment.urlApi}/departamentos/cd-departamento/${cdDepartamento}`);
  }
}
